import { render, staticRenderFns } from "./CreateTestComponent.vue?vue&type=template&id=37e078b2&scoped=true&"
import script from "./CreateTestComponent.vue?vue&type=script&lang=js&"
export * from "./CreateTestComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e078b2",
  null
  
)

export default component.exports